import { render, staticRenderFns } from "./IconCategoria.vue?vue&type=template&id=4998d153&scoped=true"
import script from "./IconCategoria.vue?vue&type=script&lang=js"
export * from "./IconCategoria.vue?vue&type=script&lang=js"
import style0 from "./IconCategoria.vue?vue&type=style&index=0&id=4998d153&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4998d153",
  null
  
)

export default component.exports